import styled from '@emotion/styled';
import { Magnetic } from "../../../styles";
export const StyledDivAvatarLayout = styled('div')((props) => `
	background: ${props.color} url(${props.url}) no-repeat scroll center;
    justify-content: center;
    margin: ${Magnetic.spacer12} auto ${Magnetic.spacer06} auto;
    width: 100%; 
    padding: ${Magnetic.spacer12};
    min-width: 148px;
    min-height: 117px;
`);
//# sourceMappingURL=WhiteLabelMobileAvatar.style.js.map